import React from "react"

interface IconProps extends React.SVGProps<SVGSVGElement> {}

/** Line Chart Icon */
export const LineChartIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
        {/* Axes */}
        <path d="M3 3v18h18" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        {/* Line */}
        <polyline points="3 17 9 11 13 15 21 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
    </svg>
)

/** Doughnut Chart Icon */
export const DoughnutChartIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" {...props}>
        {/* Outer Circle */}
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth={2} />
        {/* Inner Circle (hole) */}
        <circle cx="12" cy="12" r="5" fill="white" />
        {/* Segment */}
        <path d="M12 3a9 9 0 019 9h-9V3z" fill="currentColor" />
    </svg>
)

/** Radar Chart Icon */
export const RadarChartIcon: React.FC<IconProps> = ({ className, ...props }) => {
    const outerPoints = "12 4, 19 8, 16 17, 8 17, 5 8"
    const innerPoints = "12 8, 16 10, 14 15, 10 15, 8 10"
    return (
        <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
            {/* Outer Polygon */}
            <polygon points={outerPoints} stroke="currentColor" strokeWidth={2} strokeLinejoin="round" fill="none" />
            {/* Inner Polygon */}
            <polygon points={innerPoints} stroke="currentColor" strokeWidth={2} strokeLinejoin="round" fill="none" />
        </svg>
    )
}

/** Polar Area Chart Icon */
export const PolarAreaChartIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" {...props}>
        {/* Circle */}
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth={2} />
        {/* Segments */}
        <path d="M12 3a9 9 0 019 9h-9V3z" fill="currentColor" />
        <path d="M21 12a9 9 0 01-9 9v-9h9z" fill="currentColor" />
        <path d="M12 21a9 9 0 01-9-9h9v9z" fill="currentColor" />
        <path d="M3 12a9 9 0 019-9v9H3z" fill="currentColor" />
    </svg>
)

/** Bubble Chart Icon */
export const BubbleChartIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" {...props}>
        {/* Bubbles */}
        <circle cx="6" cy="17" r="2" />
        <circle cx="14" cy="14" r="4" />
        <circle cx="17" cy="7" r="2.5" />
    </svg>
)

/** Scatter Chart Icon */
export const ScatterChartIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" {...props}>
        {/* Points */}
        <circle cx="6" cy="17" r="1" />
        <circle cx="9" cy="13" r="1" />
        <circle cx="12" cy="15" r="1" />
        <circle cx="15" cy="9" r="1" />
        <circle cx="18" cy="11" r="1" />
    </svg>
)
